import {LoadingOutlined} from '@ant-design/icons';
import {useStore} from '@/store/root-store';
import {Button} from '@/components/common-components/components';
import styles from '../../../content-editor.module.scss';
import {Popover, Spin, Tooltip} from 'antd';
import {EditorState, Modifier, RichUtils} from 'draft-js';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleRight, faArrowsRotate, faFeather, faLink} from '@fortawesome/pro-solid-svg-icons';
import {faCheck, faCopy, faEarthAmerica, faLinkSimpleSlash, faPen} from '@fortawesome/pro-regular-svg-icons';
import 'firebase/database';
import {Input, Button as ButtonV2} from '@/components/common-components/v2';
import {observer} from 'mobx-react';
import styled from 'styled-components';
import {faCircleInfo} from '@fortawesome/pro-light-svg-icons';
import classNames from 'classnames';
import {createCompositeDecorators} from '../decorators';
import {useState} from 'react';
import {NextImg} from '@/utils/nextImg';


interface Props {
  onChange: (editorState: EditorState, isNewDecorations: boolean) => void;
  insertText: () => void;
  replaceText: () => void;
}
// eslint-disable-next-line
export const AiTooltip = observer(({onChange, insertText, replaceText}: Props) => {
  const {contentOptimizer: {currentPage, contentFragment}} = useStore('');
  const antIcon = <LoadingOutlined style={{fontSize: 16, color: '#7f4ead', marginRight: '8px'}} spin />;
  const [activeOption, setActiveOption] = useState('');
  const [urlCopy, setUrlCopy] = useState(false);
  /**
   * Method that will call different action depending on user selection from dropdown menu
   * @param {string} action used to call different actions on different items in dropdown menu
   * @returns {void}
   */

  const fetchAndInsertText = async (action: 'insert' | 'copy' | 'replace') => {
    if (!currentPage.aiTooltip.selectedText || !action) return;

    try {
      if (action === 'replace') {
        await contentFragment.fetchFragment(currentPage.aiTooltip.selectedText, true);
      } else {
        await contentFragment.fetchFragment(currentPage.aiTooltip.selectedText);
      }


      // if (action === 'replace') {
      //   replaceText();
      // }


      if (action === 'insert' || action === 'replace') {
        insertText();
      }

      if (action === 'copy') {
        currentPage.setAiTooltip({...currentPage.aiTooltip, show: false});
        if (contentFragment?.fragment?.html) {
          navigator.clipboard.writeText(contentFragment?.fragment?.html);
          currentPage.setIsCopy(true);

          setTimeout(() => {
            currentPage.setIsCopy(false);
          }, 5000);
        }
      }
    } catch (e) {
      currentPage.setAiTooltip({...currentPage.aiTooltip, show: false});
      Promise.reject(e);
    }
  };

  /**
   * Method that is called when users decide to remove a link from selection
   */

  const onLinkRemove = () => {
    if (!currentPage?.aiTooltip?.updatedSelection?.isCollapsed()) {
      onChange(RichUtils.toggleLink(currentPage.currentEditorState, currentPage.aiTooltip.updatedSelection, null), true);
      currentPage.setAiTooltip({show: false});
    }
  };

  /**
   * Method that is called when users decide to add link to selection
   */

  const sendTextToEditor = () => {
    insertLinkToText();
    // onChange(contentState, true);
    // currentPage.setAiTooltip({
    //   ...currentPage.aiTooltip,
    //   isLinkEdit: false,
    //   urlValue: '',
    //   textValue: '',
    // });
  };


  /**
   * Method that will find seelcted text and add url to it
   * It replaces selection with a new entity that we made using selected text and adding link to it
  * @return {EditorState} new editor state that was created including new url and new selectior location
  */
  const insertLinkToText = () => {
    const decorator = createCompositeDecorators(currentPage.focusTermsClassNames);
    const currentContent = currentPage.currentEditorState.getCurrentContent();

    const urlPattern = /^((http|https):\/\/)/;

    const formatUrl = urlPattern.test(currentPage.aiTooltip.urlValue) ? currentPage.aiTooltip.urlValue : `http://${currentPage.aiTooltip.urlValue}`;

    const newContentWithEntity = currentContent.createEntity(
      'LINK',
      'MUTABLE',
      {url: formatUrl},
    );

    const entityKey = newContentWithEntity.getLastCreatedEntityKey();

    const selection = currentPage.aiTooltip.updatedSelection;

    const newNewContent = Modifier.replaceText(
      currentContent,
      selection,
      currentPage.aiTooltip.textValue,
      null,
      entityKey,
    );

    const withLinkText = EditorState.createWithContent(
      newNewContent,
      decorator,
    );

    const withProperCursor = EditorState.forceSelection(
      withLinkText,
      withLinkText.getCurrentContent().getSelectionAfter(),
    );

    if (selection.isCollapsed()) {
      onChange(withProperCursor, true);
    } else {
      onChange(RichUtils.toggleLink(currentPage.currentEditorState, currentPage.aiTooltip.updatedSelection, entityKey), true);
    }


    currentPage.setAiTooltip({...currentPage.aiTooltip, isLinkEdit: false});
    return withProperCursor;
  };

  const CopiedData = () => {
    if (!currentPage.aiTooltip.selectedText) return;
    navigator.clipboard.writeText(currentPage.aiTooltip.urlValue ? currentPage.aiTooltip.urlValue : currentPage.aiTooltip.selectedText);
    setUrlCopy(true);
    setTimeout(() => {
      setUrlCopy(false);
    }, 5000);
  };

  return <div
    className={classNames(styles.selectionTooltip, window.innerHeight - currentPage.aiTooltip.bottom <= 140 ? styles.arrowBottom : null )}
    style={{
      display: currentPage.aiTooltip.show ? 'block' : 'none',
      top: (window.innerHeight - currentPage.aiTooltip.bottom) > 180 ? currentPage.aiTooltip.bottom + 15 : currentPage.aiTooltip.top - 190,

      // currentPage.content?.internalLinkSuggestions?.filter(link => link.keyword.toLowerCase() === currentPage.aiTooltip?.textValue?.trim().toLowerCase())[0] ? currentPage.aiTooltip.top - 190 : currentPage.aiTooltip.top - 150,
      left: currentPage.aiTooltip.left + ((currentPage.aiTooltip.width / 2) - 150)}}
  >
    {!currentPage.aiTooltip.isLinkEdit ? <div className={styles.selectedTextInfoContainer}>
      <div className={styles.dataAndIcon}>
        <FontAwesomeIcon icon={faEarthAmerica} style={{color: '#4E5156', paddingTop: 5, marginRight: 7}}/>
        <div className={styles.textAndUrl}>
          <Tooltip title={currentPage.aiTooltip.textValue}>
            <p className={styles.text}>{currentPage.aiTooltip.textValue}</p>
          </Tooltip>

          {currentPage.aiTooltip.urlValue && <p className={styles.url}>{currentPage.aiTooltip.urlValue}</p>}
        </div>
      </div>
      <div className={styles.textUrlControlls}>
        <Tooltip title={urlCopy ? currentPage.aiTooltip.urlValue ? 'URL copied to clipboard' : 'Text copied to clipboard' : currentPage.aiTooltip.urlValue ? 'Copy URL' : 'Copy Text'}>
          <NextImg style={{width: '15px', marginRight: 10}} src={'/img/copy-gray.svg'} onClick={CopiedData}/>
        </Tooltip>
        <FontAwesomeIcon icon={faPen} style={{marginRight: 10}} onClick={e => {
          e.stopPropagation();
          currentPage.setAiTooltip({...currentPage.aiTooltip, isLinkEdit: true});
        }}/>
        {currentPage.aiTooltip.isLink && <FontAwesomeIcon icon={faLinkSimpleSlash} onClick={() => onLinkRemove()}/>}
      </div>
    </div> :
      <div className={styles.urlPopup}>
        <div className={styles.inputContainer}>
          <p className={styles.textLabel}>Text</p>
          <Input
            onMouseDown={e => e.stopPropagation()}
            onChange={e => currentPage.setAiTooltip({
              ...currentPage.aiTooltip,
              textValue: e.target.value,
            })}
            type='text'
            value={currentPage.aiTooltip.textValue}
            placeholder='Add text'
            className={styles.urlInput}
          />
          <Input
            onMouseDown={e => e.stopPropagation()}
            onChange={e => currentPage.setAiTooltip({
              ...currentPage.aiTooltip,
              urlValue: e.target.value,
            })}
            type='text'
            value={currentPage.aiTooltip.urlValue}
            style={{marginBottom: '0px'}}
            className={styles.urlInput}
            placeholder='Paste a link'
          />
        </div>
        <div style={{display: 'flex', flexDirection: 'column', paddingTop: 20}}>
          <ButtonV2 variant='ghost' color='textGrayLight' onMouseDown={() => currentPage.setAiTooltip({...currentPage.aiTooltip, isLinkEdit: false})} className={styles.inputControlls} style={{paddingLeft: 14}}>
        Cancel
          </ButtonV2>
          <Tooltip title='Add link'>
            <ButtonV2 onMouseDown={sendTextToEditor} className={styles.inputControlls} disabled={!currentPage.aiTooltip.textValue || !currentPage.aiTooltip.urlValue}>
          Apply
            </ButtonV2>
          </Tooltip>
        </div>
      </div>}
    <Button
      buttonType='transparent'
      style={{color: '#121212', fontSize: 14}}
      disabled={contentFragment.fragmentLoading}
      onClick={e => {
        e.stopPropagation();
        setActiveOption('insert');
        fetchAndInsertText('insert');
      }}>
      {(contentFragment.fragmentLoading && activeOption === 'insert') ? <Spin indicator={antIcon} style={{width: 18, marginRight: 6}}/> : <FontAwesomeIcon icon={faFeather} style={{marginRight: 10}} />}
      <span>Write a new Paragraph for me</span>
    </Button>
    <Button
      buttonType='transparent'
      style={{color: currentPage.aiTooltip?.selectedText?.split(' ')?.filter(word => word != '')?.length > 199 ? '#A3A4A4': '#121212', fontSize: 14}}
      disabled={contentFragment.fragmentLoading || (currentPage.aiTooltip?.selectedText?.split(' ')?.filter(word => word != '')?.length > 199)}
      onClick={e => {
        e.stopPropagation();
        setActiveOption('replace');
        fetchAndInsertText('replace');
      }}>
      {(contentFragment.fragmentLoading && activeOption === 'replace') ? <Spin indicator={antIcon} style={{width: 18, marginRight: 6}}/> : <FontAwesomeIcon icon={faArrowsRotate} style={{marginRight: 10}} />}
      <span>{currentPage.aiTooltip?.selectedText?.split(' ')?.filter(word => word != '')?.length > 199 ? 'Select less than 200 words to rewrite' : 'Rewrite the Selected Text for me'}</span>
    </Button>
    <Button
      buttonType='transparent'
      style={{color: '#121212', fontSize: 14}}
      disabled={contentFragment.fragmentLoading}
      onClick={e => {
        e.stopPropagation();
        setActiveOption('copy');
        fetchAndInsertText('copy');
      }}>
      {(contentFragment.fragmentLoading && activeOption === 'copy') ? <Spin indicator={antIcon} style={{width: 18, marginRight: 6}}/> : <FontAwesomeIcon icon={faCopy} style={{marginRight: 10}} />}
      <span style={{fontSize: 14}}>Write Paragraph &amp; Copy to Clipboard</span>
    </Button>
    {currentPage.content?.internalLinkSuggestions?.filter(link => link.keyword.toLowerCase() === currentPage.aiTooltip?.textValue?.trim().toLowerCase())[0] &&
    <Popover placement='rightTop'
      overlayClassName={styles.linkSuggestionsPopover}
      overlayStyle={{background: '#fff'}}
      content={<>
        <SuggestionsContainerTitle>
          <FontAwesomeIcon icon={faCircleInfo} />
          <SuggestionsTitle>Click on any Suggestion to Link it to the selected text</SuggestionsTitle>
        </SuggestionsContainerTitle>
        {currentPage.content?.internalLinkSuggestions?.filter(link => link.keyword.toLowerCase() === currentPage.aiTooltip?.textValue?.trim().toLowerCase())[0]?.results?.map((suggestion, id) => (
          id < 10 && <SingleLinkContainer key={id} onClick={() => {
            currentPage.setAiTooltip({
              ...currentPage.aiTooltip,
              urlValue: suggestion.url,
            });
            sendTextToEditor();
          }}>
            <Left>
              <Title key={id}>{suggestion.title}</Title>
              <Link>
                {suggestion?.url}
              </Link>
            </Left>
            <Right>
              <FontAwesomeIcon icon={faCheck} style={{color: suggestion?.isUsed ? '#1FAC47' : '#4E5156', marginLeft: 'auto', marginRight: '10px'}}/>
            </Right>
          </SingleLinkContainer>
        ))
        }
      </>}>
      <SuggestionsMenuItem>
        <FontAwesomeIcon icon={faLink} style={{marginTop: 3}}/>
        <span style={{marginLeft: 10, marginTop: -2, marginRight: 65}}>Internal Link Suggestions</span>
        <FontAwesomeIcon icon={faAngleRight} style={{marginLeft: 'auto', marginRight: 20, fontSize: 14}}/>
      </SuggestionsMenuItem>
    </Popover>}
  </div>;
});


const SingleLinkContainer = styled.div`
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`;
const SuggestionsTitle = styled.span`
  display: inline-block;
  font-size: 12px;
  margin-left: 10px;
`;
const SuggestionsContainerTitle = styled.div`
  padding: 5px 12px;
  background-color: #f9f9fb;
  border: 1px solid #e8e8e8;
  margin-bottom: 10px;
`;
const SuggestionsMenuItem = styled.div`
  margin: 10px 0 5px 10px !important;
  cursor: pointer;
  width: 290px;
  font-size: 14px;
  displaye: flex;
`;
const Left = styled.div`
  width: 85%;
`;
const Right = styled.div`
  // width: 20%;
`;
const Title = styled.div`
  cursor: pointer;
  color: #121212 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis
`;
const Link = styled.a`
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
`;

